module.exports = __webpack_public_path__ + "static/media/solo-setup.1b1c291f.png";